let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dfZq9")).then(() => parcelRequire('cU76k'));